/**
 * `/merchandising/styles/$styleId/dispatch` — Dispatch, one of the Style
 * File's 7 process screens (garment Increment 8, M2).
 *
 * @see docs/product/garment-os-screen-build-plan.md §A
 */
import { createFileRoute } from "@tanstack/react-router";
import { WorkspaceShell } from "../../../../features/workspace/index.ts";
import { StyleDispatchPage } from "../../../../features/styles/index.ts";

export const Route = createFileRoute("/(workspace)/merchandising/styles/$styleId/dispatch")({
  component: StyleDispatchRoute,
});

function StyleDispatchRoute() {
  const { styleId } = Route.useParams();
  return (
    <WorkspaceShell
      breadcrumbs={[
        { label: "Merchandising", to: "/" },
        { label: "Style files", to: "/merchandising/styles" },
        { label: "Dispatch" },
      ]}
      contentClassName="max-w-none"
      viewportClassName="p-0 md:p-0"
    >
      <StyleDispatchPage styleId={styleId} />
    </WorkspaceShell>
  );
}
